import React from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  useLogin,
} from "../../../context/LoginContext";

import {
  hasPermission,
} from "../../../utils/permissions";

import {
  PanelServicesProvider,
  useAdminConfirmation,
  useAdminPrompt,
} from "../panel_engine/consumer";

import EmployeeWorkspaceShell
  from "./EmployeeWorkspaceShell";


export function resolveEmployeeAdminActionAvailability(
  currentUser,
) {
  return {
    identity: hasPermission(
      currentUser,
      "hr.employee.write",
    ),

    lifecycle: hasPermission(
      currentUser,
      "hr.employee.lifecycle",
    ),

    relationship: hasPermission(
      currentUser,
      "hr.employee.relationship",
    ),
  };
}


function EmployeeWorkspaceRouteContent() {
  const navigate =
    useNavigate();

  const confirmAction =
    useAdminConfirmation();

  const promptAction =
    useAdminPrompt();

  const {
    currentUser,
  } = useLogin();

  const actionAvailability =
    resolveEmployeeAdminActionAvailability(
      currentUser,
    );

  const {
    employeeUuid = "",
  } = useParams();

  return (
    <EmployeeWorkspaceShell
      employeeUuid={employeeUuid}
      actionAvailability={
        actionAvailability
      }
      confirmAction={confirmAction}
      promptAction={promptAction}
      onBack={() => {
        navigate(
          "/admin?panel=hr_employees",
        );
      }}
    />
  );
}


export default function EmployeeWorkspaceRoute() {
  return (
    <PanelServicesProvider>
      <EmployeeWorkspaceRouteContent />
    </PanelServicesProvider>
  );
}
